export const formatDate = (isoDateString: string) => {
    const date = new Date(isoDateString);

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    //to standard pattern
    const formattedDate = `${day}/${month}/${year}`;
    return formattedDate;
};

export const getTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

export const formatDateString = (value?: Date | string) => {
    if (!value) {
        return '';
    }

    const d = new Date(value);
    return d.toLocaleDateString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit' });
};

export const formatLocalizedShortDate = (
    value?: Date | string | null,
    options?: { includeTime?: boolean }
) => {
    if (!value) return '-';

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) return value.toString();

    const formatted = new Intl.DateTimeFormat('en-CA', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        ...(options?.includeTime && { hour: '2-digit', minute: '2-digit' }),
    }).format(date);

    if (!options?.includeTime) return formatted;

    // Normalize am/pm variants (e.g. "a.m.", "am", "p.m.") to uppercase "AM"/"PM"
    return formatted.replace(/[ap]\.?m\.?/gi, (match) => match.replace(/\./g, '').toUpperCase());
};
